import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AppComponent } from '../app.component';
import { bmxurl, getAccess } from 'src/globals';
import { cPackage, packageObj } from 'src/types/package';
import { package_returndata } from 'src/types/package_returndata';
import { v4 } from 'uuid';
import { users_returndata } from 'src/types/user_returndata';
import { GlobalService } from '../_services/global.service';
import { upgrades_returndata } from 'src/types/upgrades_returndata';
import { cUpgrade } from 'src/types/upgrades';
import { cPackageABUpgrade, cPackageUpgrade } from 'src/types/packageupgrade';
import { admissionbasedupgrades_returndata } from 'src/types/admssionbasedupgrades_returndata';

@Component({
  selector: 'app-packageaddons',
  templateUrl: './packageaddons.component.html',
  styleUrls: ['./packageaddons.component.css']
})
export class PackageaddonsComponent  implements OnInit {
  pageReady: boolean = true;
  httpResponse: any;
  id: string;
  ListPackageUpgrades: any;
  ListSelectedUpgrades: any;

  ListPackageABUpgrades: any;
  ListSelectedABUpgrades: any;

  VenueID: string = localStorage.getItem("SmartVenueID")!;
  PackageObj: cPackage;

  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;
  stateOptions: any;
  stateOptionsPerPerson: any;
  CurrencySymbol: string = localStorage.getItem("Currency") == null ? "GBP" : localStorage.getItem("Currency")!;

  ListPackage: any[] = [];
  

  constructor(private route: ActivatedRoute, private http: HttpClient, private appComp: AppComponent, private router: Router, private messageService: MessageService, private globalService: GlobalService) {
    this.stateOptions = [{ label: 'All Participants', value: true }, { label: 'Select Amount', value: false }];
    this.stateOptionsPerPerson =  [{ label: 'Per Person', value: true }, { label: 'Per Booking', value: false }];
   }

  ngOnInit(): void {

    this.globalService.setSmallScreenMenu(false);

    localStorage.removeItem("screenMemoryBookingss");
    localStorage.removeItem("screenMemoryEvents");
    
    let userid = localStorage.getItem("SmartUserID");

    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse =  (response as users_returndata)
      if(this.httpResponse.succeeded)
      {
        let user = this.httpResponse.data;

        if(getAccess("MAKEABOOKING", user)){
          this.AccessAllowed = true;
          this.getABUpgrades();
          this.getPackages(); 
        }

      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
    });
  }
  
  // UNUSED FUNCTION - commented out
  // getUpgrades()
  // {
  //   this.http.get(bmxurl + "UpgradeListall/" + this.VenueID + "/false").subscribe(response => {
  //     this.httpResponse = response
  //     if(this.httpResponse.succeeded)
  //     {
  //       this.ListPackageUpgrades = ((response as upgrades_returndata).data as cUpgrade[]);

  //       //this.getPackage();
  //     }
  //     else
  //     {
  //       this.messageService.add({severity:'error', summary:'Error', detail:'Error getting Extras, error: ' + this.httpResponse.messages[0]});
  //     }
  //   }, error => {
  //     this.messageService.add({severity:'error', summary:'Error', detail: 'Error getting Extras, error: ' + error.messages});
  //   });
  // }

  getPackages()
  {
      this.http.get(bmxurl + "packagelist/" + this.VenueID + "/false").subscribe(response => {
      if((response as package_returndata).succeeded == true)
      {
        this.ListPackage = (response as package_returndata).data.filter((item: any) => item.eventid == null);

        if ((response as package_returndata).messages.length > 0)
        {
          (response as package_returndata).messages.forEach(error => {
            this.messageService.add({severity:'warn', summary:'Response Message', detail: error});
          });
        }
      }
    }, error => {
    });
  }

  getABUpgrades()
  {
    this.http.get(bmxurl + "AdmissionBasedUpgradeList/" + this.VenueID + "/false").subscribe(response => {
      this.httpResponse = response
      if(this.httpResponse.succeeded)
      {
        this.ListPackageABUpgrades = ((response as admissionbasedupgrades_returndata).data as cUpgrade[]);
      }
      else
      {
        this.messageService.add({severity:'error', summary:'Error', detail:'Error getting Extras, error: ' + this.httpResponse.messages[0]});
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail: 'Error getting Extras, error: ' + error.messages});
    });
  }

  // UNUSED FUNCTION - commented out
  // RemoveFromList(product){
  //   this.PackageObj.packageupgrades = this.PackageObj.packageupgrades.filter(obj => obj.id !== product.id);
    
  //   this.ListPackageABUpgrades.push(product);

  //   var sortedArray: [] = this.ListPackageABUpgrades.sort((n1,n2) => {
  //     if (n1.name > n2.name) {
  //         return 1;
  //     }
  
  //     if (n1.name < n2.name) {
  //         return -1;
  //     }
  //   });

  //   this.ListPackageABUpgrades = sortedArray;
  // }

  RemoveFromABList(product){
    this.PackageObj.packageabupgrades = this.PackageObj.packageabupgrades.filter(obj => obj.id !== product.id);
    
    this.ListPackageABUpgrades.push(product);

    var sortedArray: [] = this.ListPackageABUpgrades.sort((n1,n2) => {
      if (n1.name > n2.name) {
          return 1;
      }
  
      if (n1.name < n2.name) {
          return -1;
      }
    });

    this.ListPackageABUpgrades = sortedArray;
  }
  
  // UNUSED FUNCTION - commented out
  // AddToList(product){

  //   if (this.PackageObj.packageupgrades == null)
  //   {
  //     this.PackageObj.packageupgrades = [];
  //   }

  //   if(product.max <= 0)
  //     product.max = 1;

  //   if(this.PackageObj.packageupgrades == null)
  //   {
  //     if(this.PackageObj.packageupgrades.length < 3)
  //     {
  //       let newId = v4();
  //       let newpuId = v4();

  //       this.PackageObj.packageupgrades = [];
  //       let newUpgrade: cPackageUpgrade = {
  //         id: product.id,
  //         name: product.name,
  //         packageupgradeid: newpuId,
  //         disabled: false,
  //         upgrade: product,
  //         price: 0,
  //         venueid: product.venueId,
  //         perperson: false,
  //         order: 0,
  //         isupgrade: true,
  //         quantityremaining: 0,
  //         optional: false,
  //       }

  //       this.PackageObj.packageupgrades.push(newUpgrade);
  //       this.ListPackageUpgrades = this.ListPackageUpgrades.filter(obj => obj.id !== product.id);
  //     }
  //     else
  //     {
  //       this.messageService.add({severity:'error', summary:'Error', detail:'You can only have a maximum of 3 upgrades per package'});
  //     }
  //   }
  //   else{
  //     if(this.PackageObj.packageupgrades.length < 3)
  //     {
  //       let newId = v4();
  //       let newpuId = v4();

  //       let newUpgrade: cPackageUpgrade = {
  //         id: newId,
  //         name: product.name,
  //         packageupgradeid: newpuId,
  //         disabled: false,
  //         upgrade: product,
  //         price: 0,
  //         venueid: product.venueId,
  //         perperson: false,
  //         order: 0,
  //         isupgrade: true,
  //         quantityremaining: 0,
  //         optional: false
  //       }

  //       this.PackageObj.packageupgrades.push(newUpgrade);
  //       this.ListPackageUpgrades = this.ListPackageUpgrades.filter(obj => obj.id !== product.id);
  //     }
  //     else
  //     {
  //       this.messageService.add({severity:'error', summary:'Error', detail:'You can only have a maximum of 3 upgrades per package'});
  //     }
  //   }
  // }

  AddToABList(product){

    if (this.PackageObj.packageabupgrades == null)
    {
      this.PackageObj.packageabupgrades = [];
    }

    if(product.max <= 0)
      product.max = 1;

    if(this.PackageObj.packageabupgrades == null)
    {
      if(this.PackageObj.packageabupgrades.length < 3)
      {
        let newId = v4();
        let newpuId = v4();

        this.PackageObj.packageabupgrades = [];
        let newUpgrade: cPackageABUpgrade = {
          id: product.id,
          name: product.name,
          packageupgradeid: newpuId,
          disabled: false,
          upgrade: product,
          price: 0,
          venueid: product.venueId,
          perperson: true,
          order: 0,
          isupgrade: true,
          quantityremaining: 0,
          optional: false,
          quantity: 1
        }

        this.PackageObj.packageabupgrades.push(newUpgrade);
        this.ListPackageABUpgrades = this.ListPackageABUpgrades.filter(obj => obj.id !== product.id);
      }
      else
      {
        this.messageService.add({severity:'error', summary:'Error', detail:'You can only have a maximum of 3 upgrades per package'});
      }
    }
    else{
      if(this.PackageObj.packageabupgrades.length < 3)
      {
        let newId = v4();
        let newpuId = v4();

        let newUpgrade: cPackageABUpgrade = {
          id: product.id,
          name: product.name,
          packageupgradeid: newpuId,
          disabled: false,
          upgrade: product,
          price: 0,
          venueid: product.venueId,
          perperson: true,
          order: 0,
          isupgrade: true,
          quantityremaining: 0,
          optional: false,
          quantity: 0
        }

        this.PackageObj.packageabupgrades.push(newUpgrade);
        this.ListPackageABUpgrades = this.ListPackageABUpgrades.filter(obj => obj.id !== product.id);
      }
      else
      {
        this.messageService.add({severity:'error', summary:'Error', detail:'You can only have a maximum of 3 upgrades per package'});
      }
    }
  }

  // UNUSED FUNCTION - commented out
  // resettotals(extraindex)
  // {
  //   this.PackageObj.extras[extraindex].min = 0;
  //   this.PackageObj.extras[extraindex].max = 0;
  // }

  updateData()
  {
    let order = 0;
    this.PackageObj.packageupgrades.forEach(item =>
    {
      item.order = order;
      order ++;
    });

    this.http.put<packageObj>(bmxurl + "/package", this.PackageObj).subscribe(response => {
      this.httpResponse = response
      if (this.httpResponse.succeeded) {
        this.messageService.add({ severity: 'success', summary: 'Saved', detail: 'Package successfully updated' });
        this.router.navigateByUrl("/package");
      }
    }, error => {
      this.messageService.add({ severity: 'error', summary: 'Not Saved', detail: error.messages });
    })
  }

  packageChanged()
  {
    if(this.PackageObj.packageabupgrades !=null && this.PackageObj.packageabupgrades.length > 0)
    {
      this.PackageObj.packageabupgrades.forEach(item => {
        this.ListPackageABUpgrades = this.ListPackageABUpgrades.filter(obj => obj.id !== item.upgrade.id);
      });

      this.CompletedLoading = true;
      this.pageReady = true;
    }
  }

  returnToList()
  {
    this.router.navigateByUrl("/package");
  }

  getPackage() {
    if (this.id != "0") {
      this.http.get(bmxurl + "package/" + this.VenueID + "/" + this.id).subscribe(response => {
        this.httpResponse = (response as package_returndata)
        this.PackageObj = {
          id: (this.httpResponse.data as cPackage).id,
          packageId: (this.httpResponse.data as cPackage).packageId,
          name: (this.httpResponse.data as cPackage).name,
          eventid: (this.httpResponse.data as cPackage).eventid,
          description: (this.httpResponse.data as cPackage).description,
          imageurl: (this.httpResponse.data as cPackage).imageurl,
          message: (this.httpResponse.data as cPackage).message,
          disabled: (this.httpResponse.data as cPackage).disabled,
          venueID: (this.httpResponse.data as cPackage).venueID,
          resources: (this.httpResponse.data as cPackage).resources,
          startTimes: (this.httpResponse.data as cPackage).startTimes,
          admissions: (this.httpResponse.data as cPackage).admissions,
          packageLength: (this.httpResponse.data as cPackage).packageLength,
          questionnaire: (this.httpResponse.data as cPackage).questionnaire,
          min: (this.httpResponse.data as cPackage).min,
          max: (this.httpResponse.data as cPackage).max,
          visibility: (this.httpResponse.data as cPackage).visibility,
          tags: (this.httpResponse.data as cPackage).tags,
          startDate: new Date((this.httpResponse.data as cPackage).startDate),
          endDate: new Date((this.httpResponse.data as cPackage).endDate),
          colour: (this.httpResponse.data as cPackage).colour,
          packageRule: (this.httpResponse.data as cPackage).packageRule,
          packageRestriction: (this.httpResponse.data as cPackage).packageRestriction,
          extras: (this.httpResponse.data as cPackage).extras,
          publicDepositPolicy: (this.httpResponse.data as cPackage).publicDepositPolicy,
          venueDepositPolicy: (this.httpResponse.data as cPackage).venueDepositPolicy,
          additionalresources: (this.httpResponse.data as cPackage).additionalresources,
          confirmation:  (this.httpResponse.data as cPackage).confirmation,
          warning:  (this.httpResponse.data as cPackage).warning,
          originatingid:  (this.httpResponse.data as cPackage).originatingid,
          bookingscannotbemadewithinxminutes: (this.httpResponse.data as cPackage).bookingscannotbemadewithinxminutes,
          bookingscannotbemadeafterxminutes: (this.httpResponse.data as cPackage).bookingscannotbemadeafterxminutes,
          cannotmakebookingstoday: (this.httpResponse.data as cPackage).cannotmakebookingstoday,
          discounttype: (this.httpResponse.data as cPackage).discounttype,
          discountamount: (this.httpResponse.data as cPackage).discountamount,
          discountcode: (this.httpResponse.data as cPackage).discountcode,
          discountstart: (this.httpResponse.data as cPackage).discountstart,
          discountend: (this.httpResponse.data as cPackage).discountend,
          earlybirddiscount: (this.httpResponse.data as cPackage).earlybirddiscount,
          discountrangetype: (this.httpResponse.data as cPackage).discountrangetype,
          discountdaysbefore: (this.httpResponse.data as cPackage).discountdaysbefore,
          imageguid: (this.httpResponse.data as cPackage).imageguid,
          bookingtimeout: (this.httpResponse.data as cPackage).bookingtimeout,
          maxcalendarmonths: (this.httpResponse.data as cPackage).maxcalendarmonths,
          packageupgrades: (this.httpResponse.data as cPackage).packageupgrades,
          packageabupgrades: (this.httpResponse.data as cPackage).packageabupgrades,
          waiverrequired: (this.httpResponse.data as cPackage).waiverrequired,
          ispartypackage: (this.httpResponse.data as cPackage).ispartypackage,
          bookingfeeid: (this.httpResponse.data as cPackage).bookingfeeid,
          portaltemplateid: (this.httpResponse.data as cPackage).portaltemplateid,
          cannotbepaidwithvoucher: (this.httpResponse.data as cPackage).cannotbepaidwithvoucher,
          //Carried through so saving add-ons doesn't wipe a repeatable package's dates.
          repeatable: (this.httpResponse.data as cPackage).repeatable ?? false,
          repeatdates: (this.httpResponse.data as cPackage).repeatdates ?? [],
          //Carried through with the rest. This screen rebuilds the package field by field and
          //puts it straight back, so a block package saved from here would lose its blocks.
          repeatmode: (this.httpResponse.data as cPackage).repeatmode ?? 'FREE',
          repeatblocks: (this.httpResponse.data as cPackage).repeatblocks ?? [],
          repeatmaxdates: (this.httpResponse.data as cPackage).repeatmaxdates ?? 0,
          repeatblockpricefrom: (this.httpResponse.data as cPackage).repeatblockpricefrom ?? 0
        }

        if(this.PackageObj.packageabupgrades !=null && this.PackageObj.packageabupgrades.length > 0)
        {
          this.PackageObj.packageabupgrades.forEach(item => {
            this.ListPackageABUpgrades = this.ListPackageABUpgrades.filter(obj => obj.id !== item.upgrade.id);
          });

          this.CompletedLoading = true;
          this.pageReady = true;
        }

      }, error => {
      }
      );
    }
  }
}
